<template>
  <div class="bottom_main">
    <div class="btm_url">
      <router-link to="/ys">隐私权保护政策</router-link>
      <span class="btm_xx">|</span>
      <router-link to="/xy">用户协议</router-link>
      <span class="btm_xx">|</span>
      <router-link to="/jz">家长监护</router-link>
      <span class="btm_xx">|</span>
      <router-link to="/service">客服中心</router-link>
      <span class="btm_xx">|</span>
      <router-link to="/us">关于我们</router-link>
    </div>
    <div class="btm_comps">
      <br>
      运营单位：<span style="color: #ddd;">{{company.main}} {{company.mainEN}}</span><br>
      办公地址： {{company.address}}<br>
      电话：{{company.telephone}} 邮编：{{company.Postcode}}<br>
      {{company.wangwen}} {{company.appBei}}
      {{company.banhao}}<br>
      <a href="https://beian.miit.gov.cn" target="_blank" style="color: #999;">{{company.IPC}}</a><br><br>
      抵制不良游戏，拒绝盗版游戏，注意自我保护，谨防上当受骗<br>
      适度游戏益脑，沉迷游戏伤身，合理安排时间，享受健康生活<br>
      本平台游戏仅适合16岁以上人群<br>
      <br>
    </div>
    <div style="color: rgb(147, 147, 147);">
      中宣部游戏备案号：{{company.zhongxuanbu}}
    </div>
    <div style="width:300px;margin:0 auto; padding:10px 0; display: none;" >
      <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=37021302000818" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
        <img src="@/assets/beian.png" style="float:left;"/>
        <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">{{company.gonganBeian}}</p>
      </a>
    </div>
    <div class="btm_url" style="padding-bottom: 20px; line-height: 1.2rem;">
      <div class="youqing_title">友情链接</div>
      <a href="http://www.nppa.gov.cn/" target="_blank" class="link_a">国家新闻出版广电总局</a>
      <span class="btm_xx">|</span>
      <a href="https://www.mct.gov.cn/" target="_blank" class="link_a">中华人民共和国文化和旅游部</a>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src
// import tools from '@/tools/tools'

export default {
  name: 'BottomMobile',
  data: () => {
    return {
      isShowCode: false
    }
  },
  methods: {
    onToTop () {
      document.body.scrollTop = document.documentElement.scrollTop = 0
    }
  },
  computed: {
    company () {
      return this.$store.state.configs.company
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.youqing_title {
  color: #ddd;
}
.link_a:hover {
  color: #3c7cec;
}
.bottom_main {
  background: rgb(35, 35, 35);
  padding: 1rem 0;
}
.btm_img {
  width: 2rem;
}

.btm_top_s {
  margin-left: 0.3rem;
  position: relative;
  top: -0.6rem;
}
.btm_url {
  margin-top: 1rem;
  color: #bbb;
  font-size: 14px;
}
.btm_url a {
  color: #ddd;
  text-decoration: none;
}
.btm_xx {
  padding: 0 0.3rem;
}
.btm_comps {
  color: #999;
  font-size: 12px;
  font-weight: lighter;
}
</style>
